// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  qivosRestURL: 'https://demo.uat.qivos.net/rest-ci-demo-UAT',
  qcURL: 'https://demo.uat.qivos.net/qc-api/v1.0',
  qivosApiURL: 'https://api-staging.qivos.net',
  merchantURL: 'https://merchant.uat.qivos.net',
  idpURL: 'https://demo.uat.qivos.net/idp-api/public/public/auth',
  bucketURL: 'static.cldbz.net/uat/demo',
  clientName: 'demo',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
